<div class="p-3 mb-4 border border-danger">
    <p class="font-weight-bold text-danger text-center mb-3">{{'A suggested address has been provided. Click an address below to continue' | translate}}</p>
    <div class="row m-0">
        <div class="suggested-container col p-3 mr-2">
            <div class="col-12 px-0 d-inline-flex justify-content-between mb-3">
                <p class="mb-0 font-weight-bold">{{'Suggested:' | translate}}</p>
                <button (click)="choiceEmitter.emit(suggestedAddress)" class="btn btn-sm btn-outline-secondary">{{'Select' | translate}}</button>
            </div>
            <div class="col-12 text-center px-0">
                <p class="mb-0">{{ suggestedAddress.addressLine1 }}</p>
                <p class="mb-0">{{ suggestedAddress.townCity }}</p>
                <p class="mb-0">{{ suggestedAddress.countyState }}</p>
                <p class="mb-0">{{ suggestedAddress.postalCode }}</p>
                <p class="mb-0">{{ suggestedAddress.countryName }}</p>
            </div>
        </div>
        <div class="my-address-container col p-3 ml-2">
            <div class="col-12 px-0 d-inline-flex justify-content-between mb-3">
                <p class="mb-0 font-weight-bold">{{'My Address:' | translate}}</p>
                <button (click)="choiceEmitter.emit(address)" class="btn btn-sm btn-outline-secondary">{{'Select' | translate}}</button>
            </div>
            <div class="col-12 text-center px-0">
                <p class="mb-0">{{ address?.addressLine1 }}</p>
                <p class="mb-0">{{ address?.townCity }}</p>
                <p class="mb-0">{{ address?.countyState }}</p>
                <p class="mb-0">{{ address?.postalCode }}</p>
                <p class="mb-0">{{ address?.countryName }}</p>
            </div>
        </div>
    </div>
</div>
 